import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import styles from "./header.module.css"

@tagName("")
export default class PlannerHeader extends Component {
  readonly styles = styles

  // args
  dateRangeString!: string
  setNewDate!: Function
  back!: Function
  forward!: Function
  date!: string
  hideNav!: boolean
  planbook!: Planbook
  rotationCalendar!: RotationCalendar

  menuConstraints = [
    {
      to: "window",
      attachment: "together",
      pin: "right",
    },
  ]

  // props
  canShowMenu = false
  isDayMenuOpen = false

  @action toggleDayMenu() {
    this.isDayMenuOpen = !this.isDayMenuOpen
  }

  @action
  toggleMenu() {
    this.set("canShowMenu", !this.canShowMenu)
  }
}
